import {Component, Vue} from "vue-property-decorator";
import {fetchDossierDocuments, fetchOrderDocuments, getFileUrl} from "../../../services/dossier-service";


@Component({})
export default class DossierDocsMixin extends Vue {
    public docLoading: boolean = false;
    public dossierFiles = [];

    async getDossierDocument(dossierId: number, query?: { [key: string]: string | boolean }) {
        this.docLoading = true;
        const response = await fetchDossierDocuments(dossierId, query);
        if (response) {
            this.dossierFiles = response;
            this.docLoading = false;
            return response.files.length > 0 && response.files[0].dossier;
        } else {
            this.docLoading = false;
        }
    }

    async getOrderDocument(dossierId: number) {
        this.docLoading = true;
        const response = await fetchOrderDocuments(dossierId);
        if (response) {
            this.dossierFiles = response;
            this.docLoading = false;
            return true
        } else {
            this.docLoading = false;
        }
    }

    async getFileData(docId: number) {
        this.docLoading = true;
        const file = await getFileUrl(docId);
        // const convertedFile =
        //     file ? "data:" + this.getFileHeader(file.extension) + ";base64," + file.content
        //         : "No Data";
        this.docLoading = false;
        return this.b64toBlob(file.content, file.extension);
        // return convertedFile;
    }

    getFileHeader(extension: string) {
        switch (extension) {
            case "zip":
                return "application/zip";
            default:
                return extension;
        }
    }

    b64toBlob(b64Data: string, contentType: string = '', sliceSize = 512) {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        return new Blob(byteArrays, {type: contentType});
    }
}
